import React from 'react';
import { Card } from '../ui/card';
import { ArrowTrendingUpIcon, ArrowTrendingDownIcon } from '@heroicons/react/24/outline';

const StatCard = ({ label, value, icon: Icon, change, isPositive = true }) => (
  <Card className="flex flex-col p-5 min-w-[200px] h-28 justify-between">
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        {Icon && <Icon className="w-4 h-4 text-muted-foreground" />}
        <span className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">{label}</span>
      </div>
    </div>
    <div className="flex items-center gap-3">
      <h3 className="text-2xl font-bold">{value}</h3>
      {change && (
        <div className="flex items-center gap-1 text-xs font-semibold text-muted-foreground">
          {isPositive ? (
            <ArrowTrendingUpIcon className="w-3 h-3 text-brand-cta" />
          ) : (
            <ArrowTrendingDownIcon className="w-3 h-3 text-destructive" />
          )}
          {change}
        </div>
      )}
    </div>
  </Card>
);

export default StatCard;
